import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=1335fed7&scoped=true"
var script = {}
import style0 from "./authority.vue?vue&type=style&index=0&id=1335fed7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1335fed7",
  null
  
)

export default component.exports